import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-call-waiter-indicator',
  standalone: true,
  templateUrl: './call-waiter-indicator.component.html',
  styleUrls: ['./call-waiter-indicator.component.scss'],
  host: {
    '[class.active]': 'active()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallWaiterIndicatorComponent {

  public readonly active = input<boolean>(false);

}
